module.exports = __webpack_public_path__ + "img/witch-cauldron.7b2041a0.png";